import { connect } from 'react-redux';

import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import { ApplicationState } from '../../store';
import { ReportTypesManager } from '../../store/Managers/ReportTypesManager';
import { ReportContext } from '../../store/Models/Customers/Customer';
import { ReportTypeSelector } from '../core/ReportTypeSelector';
import { LoadingSpinner, LoadingSpinnerSize } from '../core/LoadingSpinner';
import { SharedMaterialsFullCompany } from '../../store/Models/SharedMaterials/DataModel';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';


// ===============================================================================
//
// Modal to select report types for creating reports for a customer.
//

interface PickReportsModalOwnProps {
    reportsToRender: string[];
    onReportsSelected: (selectedReports: { [reportType: string]: ReportContext | null }) => void;
}

type PickReportsModalProps =
    PickReportsModalOwnProps & 
    ToxnotComponentProperties;

interface PickReportsModalState {
    selectedReportTypes: { [reportType: string]: ReportContext | null }
    reportTypesAndRegulationsToSpecificInfo: { [reportTypeOrRegulation: string]: string }
}

class PickReportsForCompanyModal extends ToxnotSignInRequiredComponent<PickReportsModalProps, PickReportsModalState> {
    constructor(props: PickReportsModalProps) {
        super(props);

        this.state = {
            selectedReportTypes: {},
            reportTypesAndRegulationsToSpecificInfo: {},
        }
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    public renderConcreteComponent() {
        return (
            <div id="pick-reports-for-company-modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4>{this.props.appServices.localizeString("Select the reports you want to share")}</h4>
                        </div>
                        <div className="modal-body">
                            {this.renderModalBody()}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal">{this.props.appServices.localizeString("Close")}</button>
                            {Object.keys(this.state.selectedReportTypes).length > 0 && <button type="button" onClick={e => this.selectReports_click()} className="btn btn-toxnot-primary">{this.props.appServices.localizeString("Select Reports")}</button>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // ===============================================================================

    public renderModalBody() {
        const reportTypesAndRegulationsForUser = this.getUserContextForSignedInUser().reportTypesAndRegulations;

        const reportTypesToUse = reportTypesAndRegulationsForUser.allowedReportTypesForUser.filter(r => ReportTypesManager.allowedBulkReportTypes.includes(r));

        return <ReportTypeSelector
            renderOptions={
                {
                    onlyAllowSingleSelection: !this.getUserContextForSignedInUser().userCapabilities.myCustomersEnabled,
                    showListInput: false,
                    showRegulations: false,
                    initialSelectedReportsTypes: ReportTypesManager.getReportTypesAndContextFromReportTypes(this.props.reportsToRender, reportTypesAndRegulationsForUser.reportTypeToRegulations)
                }
            }
            appServices={this.props.appServices}
            reportTypesAndContexts={ReportTypesManager.getReportTypesAndContextFromReportTypes(reportTypesToUse, reportTypesAndRegulationsForUser.reportTypeToRegulations)}
            reportSelectedCallback={this.reportTypeSelector_reportSelected}
            isFreeUser={!this.getUserCapabilities().myCustomersEnabled}
            dynRegs={this.getUserContextForSignedInUser().reportTypesAndRegulations.dynRegsForUser}
        />
    }

    // ===============================================================================

    private reportTypeSelector_reportSelected = (selectedReports: { [reportType: string]: ReportContext | null }, reportTypesAndRegulationsToSpecificInfo: { [reportTypeOrRegulation: string]: string }) => {
        this.setState({
            selectedReportTypes: selectedReports,
            reportTypesAndRegulationsToSpecificInfo: { ...reportTypesAndRegulationsToSpecificInfo },
        });
    }

    // ===============================================================================
    //
    // UI Events
    //

    private selectReports_click = () => {
        this.props.onReportsSelected(this.state.selectedReportTypes);
        $('#pick-reports-for-company-modal').modal('hide');
    }
}

export default connect(
    (state: ApplicationState, ownProps: PickReportsModalOwnProps) => ({appServices: state.appServices }),
)(PickReportsForCompanyModal as any);